import React from 'react';
import PlaylistForm from './PlaylistForm';

const PlaylistCreatePage = () => {
  return (
    <PlaylistForm />
  );
};

export default PlaylistCreatePage;